import Price from './price'

export default Price
